import { createAction, props } from '@ngrx/store';
import { Endorsement } from '../../models/form-state.model';

export const putEndorsements = createAction(
  '[Endorsement] Put Endorsements',
  props<{ payload: Endorsement[] }>()
);

export const init = createAction('[Init]');
